/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { useState, useEffect } from "react";
import moment from 'moment';
import { TokenDisplayService } from "../../../services/token-display-service";
import { getId } from "./getId.helper";
import bandsConfig from "../../../config/bands.config.json";
import defaultConfig from "../../../config/default.config.json";

const getSrv = () => {
  const { id } = getId();
  if (id) {
    const found = bandsConfig?.bands?.find((band: any) => band.key === id);
    if (found?.topic) {
      return TokenDisplayService.getInstance({
        mqttConfig: {
          brokerURL: defaultConfig?.mqttServiceConfig?.MQTT_BROKER_URL,
          username: defaultConfig?.mqttServiceConfig?.MQTT_USERNAME,
          password: defaultConfig?.mqttServiceConfig?.MQTT_PASSWORD,
        },
        topics: [found.topic],
      });
    }
  }
  console.log("id not found !!!");
  return null;
};

export const useTokenDisplay = () => {
  const [message, setMessage] = useState<any>(null);
  // const [fingerPrint, setFingerprint] = useState<any>(null);

  // This hook is to subscribe MQTT messages
  useEffect(() => {
    const srv = getSrv();
    if (srv) {
      console.log("getTokenDisplayEventBus")
      const eb = srv?.getTokenDisplayEventBus();
      eb.on("io.vlinder.tokenDisplay", (payload: any) => {
        console.log("tokenDisplay msg received");
        if (payload) {
          const { id } = getId();
          // setFingerprint(`${id}-${moment().format('HHmmss')}`);
          setMessage({
            cardData: payload?.message,
            fingerprint: `${id}-${moment().format('HHmmss')}`,
          });
        }
      });

      // eb.on("io.vlinder.tokenDisplay.fingerprint", (payload: any) => {
      //   console.log("tokenDisplay finger print msg received");
      //   const { id } = getId();
      //     setFingerprint(`${id}-${moment().format('HHmmss')}`);
      // });

    }
    return () => {
      // this now gets called when the component unmounts
      // srv?.disconnectMQTTClient();
    };
  }, []);

  useEffect(() => {
    const srv = getSrv();
    if (srv) {
       const { id } = getId();
       const flow = bandsConfig.bands.find(o => o.key === id?.trim());
       if (flow?.name) {
         srv.getVQMSData(flow.name)
             .then(res => {
                setMessage({
                  cardData: res,
                  fingerprint: `${id}-${moment().format('HHmmss')}`,
                });
             })
       }
    }
  }, []);

  const { id } = getId();
  let logo: any;
  if (id) {
    const found = bandsConfig?.bands?.find((band: any) => band.key === id);
    if (found?.logo) {
      logo = found.logo;
    }
  }

  return {
    message,
    setMessage,
    // fingerPrint,
    logo,
    id,
  };
};
